import { Config } from '@/config';
import { ApiService } from '@/services/api.service';
import {
  transformActionFilters,
  transformFollowedFiltersToArray,
  transformReadFiltersToArray,
  transformSharedFiltersToArray,
} from '@/util/action-filters-util';
import { expandToZones, mapToZones } from '@/util/zones-util';
import axios from 'axios';

const CancelToken = axios.CancelToken;
let cancelTokenSave = null;

class UserProfileService {
  getUserProfile() {
    return ApiService.get(`${Config.api.tender.url}user-profiles`).then((response) => response.data);
  }

  saveUserProfile(userProfile) {
    if (cancelTokenSave) {
      cancelTokenSave.cancel('Multiple requests.');
    }
    cancelTokenSave = CancelToken.source();

    return ApiService.post(`${Config.api.tender.url}user-profiles`, userProfile, {
      cancelToken: cancelTokenSave.token,
    }).then((response) => response.data);
  }

  patchUserProfile(userProfile) {
    if (cancelTokenSave) {
      cancelTokenSave.cancel('Multiple requests.');
    }
    cancelTokenSave = CancelToken.source();

    return ApiService.patch(`${Config.api.tender.url}user-profiles`, userProfile, {
      cancelToken: cancelTokenSave.token,
    }).then((response) => response.data);
  }

  getSearchFilters() {
    return ApiService.get(`${Config.api.tender.url}user-profiles/search-filters`).then((response) =>
      mapToResult(response.data),
    );
  }

  setSearchFilters(filters) {
    return ApiService.put(`${Config.api.tender.url}user-profiles/search-filters`, mapToParameters(filters)).then(
      (response) => mapToResult(response.data),
    );
  }
}

const mapToParameters = ({
  userId,
  tenantId,
  platforms,
  statuses,
  closingBefore,
  keywordIds,
  matchContexts,
  procurementCategories,
  zones,
  readFilters,
  shareFilters,
  followFilters,
  assigneesFilters,
  administrativeRegions,
  classifications,
}) => ({
  userId: userId,
  tenantId: tenantId,
  platforms: platforms && platforms.length > 0 ? platforms : null,
  statuses: statuses && statuses.length > 0 ? statuses : null,
  closingBefore: closingBefore ? closingBefore : null,
  keywordIds: keywordIds && keywordIds.length > 0 ? keywordIds : null,
  matchContexts: matchContexts && matchContexts.length > 0 ? matchContexts : null,
  procurementCategories: procurementCategories && procurementCategories.length > 0 ? procurementCategories : null,
  zones: zones ? expandToZones(zones) : null,
  read: transformActionFilters(readFilters).read,
  shared: transformActionFilters(shareFilters).shared,
  followed: transformActionFilters(followFilters).followed,
  assignees: assigneesFilters && assigneesFilters.length > 0 ? assigneesFilters : null,
  administrativeRegions: administrativeRegions ? administrativeRegions : null,
  classifications: classifications ? classifications : null,
});

const mapToResult = ({
  userId,
  tenantId,
  platforms,
  administrativeRegions,
  statuses,
  closingBefore,
  keywordIds,
  matchContexts,
  procurementCategories,
  zones,
  read,
  followed,
  shared,
  assignees,
  classifications,
}) => ({
  userId: userId,
  tenantId: tenantId,
  platforms: platforms ? platforms : [],
  statuses: statuses ? statuses : [],
  closingBefore: closingBefore ? closingBefore : null,
  keywordIds: keywordIds ? keywordIds : [],
  matchContexts: matchContexts ? matchContexts : [],
  procurementCategories: procurementCategories ? procurementCategories : [],
  zones: zones ? mapToZones(zones) : null,
  readFilters: transformReadFiltersToArray(read),
  followFilters: transformFollowedFiltersToArray(followed),
  shareFilters: transformSharedFiltersToArray(shared),
  assigneesFilters: assignees ? assignees : [],
  administrativeRegions: administrativeRegions ? administrativeRegions : {},
  classifications: classifications ? classifications : [],
});

export const userProfileService = new UserProfileService();
